import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const authHeader = (): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Motivos da parada do serviço (at-134, ADR 0065).
 *
 * ⚠️ NENHUMA função aqui engole erro (at-60): "nenhum motivo cadastrado" desliga a exigência, e
 * "não consegui perguntar" precisa bloquear a escolha — confundir os dois faria a tela mandar um
 * pedido sem motivo que o backend recusaria.
 */
export interface MotivoDeParadaAtivo {
  id: string;
  nome: string;
  /** "Outro": a escolha só vale com o detalhe em texto. */
  exigeTexto: boolean;
}

export interface MotivoDeParada extends MotivoDeParadaAtivo {
  ordem: number;
  ativo: boolean;
}

export const buscarMotivosDeParadaAtivos = async (): Promise<MotivoDeParadaAtivo[]> => {
  const { data } = await axios.get(`${BACKEND_URL}/motivos-de-parada/ativos`, { headers: authHeader() });
  return data;
};

export const buscarMotivosDeParada = async (): Promise<MotivoDeParada[]> => {
  const { data } = await axios.get(`${BACKEND_URL}/motivos-de-parada`, { headers: authHeader() });
  return data;
};

export const criarMotivoDeParada = async (body: { nome: string; exigeTexto?: boolean }): Promise<MotivoDeParada> => {
  const { data } = await axios.post(`${BACKEND_URL}/motivos-de-parada`, body, { headers: authHeader() });
  return data;
};

export const atualizarMotivoDeParada = async (
  id: string,
  body: { nome?: string; exigeTexto?: boolean; ativo?: boolean },
): Promise<MotivoDeParada> => {
  const { data } = await axios.patch(`${BACKEND_URL}/motivos-de-parada/${id}`, body, { headers: authHeader() });
  return data;
};

export const desativarMotivoDeParada = async (id: string): Promise<MotivoDeParada> => {
  const { data } = await axios.delete(`${BACKEND_URL}/motivos-de-parada/${id}`, { headers: authHeader() });
  return data;
};

export const reordenarMotivosDeParada = async (ids: string[]): Promise<MotivoDeParada[]> => {
  const { data } = await axios.put(`${BACKEND_URL}/motivos-de-parada/reorder`, { ids }, { headers: authHeader() });
  return data;
};
